import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["menu", "closeMenuButton", "openMenuButton", "header"];

    initialize() {
    }

    openMenu() {
        // On menu open...
        if (!this.mandatoryCondition()) return
        // Hide open menu button
        if (!this.openMenuButtonTarget.classList.contains('hidden')) this.openMenuButtonTarget.classList.add('hidden');
        // Show close menu button
        if (this.closeMenuButtonTarget.classList.contains('hidden')) this.closeMenuButtonTarget.classList.remove('hidden');
        // Fix the header
        if (!this.headerTarget.classList.contains('fixed')) this.headerTarget.classList.add('fixed');
        // Show menu
        if (!this.menuTarget.classList.contains('active')) this.menuTarget.classList.add('active')
    }

    closeMenu() {
        // On close open...
        if (!this.mandatoryCondition()) return
        // Hide close menu button
        if (!this.closeMenuButtonTarget.classList.contains('hidden')) this.closeMenuButtonTarget.classList.add('hidden');
        // Show open menu button
        if (this.openMenuButtonTarget.classList.contains('hidden')) this.openMenuButtonTarget.classList.remove('hidden');
        // UnFix the header
        if (this.headerTarget.classList.contains('fixed')) this.headerTarget.classList.remove('fixed');
        // Hide menu
        if (this.menuTarget.classList.contains('active')) this.menuTarget.classList.remove('active')
    }

    mandatoryCondition() {
        return this.hasMenuTarget && this.hasCloseMenuButtonTarget && this.hasOpenMenuButtonTarget && this.hasHeaderTarget
    }

    disconnect() {
    }
}
